import React from "react";
import "./WeAreQrCards.scss";
import { FormattedMessage } from "react-intl";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper";
import "swiper/scss";
import "swiper/css/navigation";

function WeAreQrCards() {
  return (
    <section id="we-are-qr-cards">
      <h2>
        <FormattedMessage id="home.team.h" />
      </h2>
      <div className="sub-heading">
        <FormattedMessage id="home.team.p" />
      </div>
      <div className="wrapper">
        <div className="block">
          <div className="img-wrapper">
            <img src="images/we-are-qr-cards/img1.svg" alt="" />
          </div>
          <h6>
            <FormattedMessage id="home.team.h1" />
          </h6>
          <p>
            <FormattedMessage id="home.team.p1" />
          </p>
        </div>
        <div className="block">
          <div className="img-wrapper">
            <img src="images/we-are-qr-cards/img2.svg" alt="" />
          </div>
          <h6>
            <FormattedMessage id="home.team.h2" />
          </h6>
          <p>
            <FormattedMessage id="home.team.p2" />
          </p>
        </div>
        <div className="block">
          <div className="img-wrapper">
            <img src="images/we-are-qr-cards/img3.svg" alt="" />
          </div>
          <h6>
            <FormattedMessage id="home.team.h3" />
          </h6>
          <p>
            <FormattedMessage id="home.team.p3" />
          </p>
        </div>
      </div>
      <Swiper
        slidesPerView={1}
        spaceBetween={30}
        loop={true}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Pagination, Navigation]}
        className="mySwiper swiper"
      >
        <SwiperSlide className="block">
          <div className="img-wrapper">
            <img src="images/we-are-qr-cards/img1.svg" alt="" />
          </div>
          <h6>
            <FormattedMessage id="home.team.h1" />
          </h6>
          <p>
            <FormattedMessage id="home.team.p1" />
          </p>
        </SwiperSlide>
        <SwiperSlide className="block">
          <div className="img-wrapper">
            <img src="images/we-are-qr-cards/img2.svg" alt="" />
          </div>
          <h6>
            <FormattedMessage id="home.team.h2" />
          </h6>
          <p>
            <FormattedMessage id="home.team.p2" />
          </p>
        </SwiperSlide>
        <SwiperSlide className="block">
          <div className="img-wrapper">
            <img src="images/we-are-qr-cards/img3.svg" alt="" />
          </div>
          <h6>
            <FormattedMessage id="home.team.h3" />
          </h6>
          <p>
            <FormattedMessage id="home.team.p3" />
          </p>
        </SwiperSlide>
      </Swiper>
    </section>
  );
}

export default WeAreQrCards = React.memo(WeAreQrCards);
